<template>
    <div
        class="base_title"
        :class="{
            center: center,
        }"
        :style="`color:${color ? color : ''}`"
    >
        <img
            v-if="icon === 'white'"
            src="../../../assets/base-title-icon-2.png"
        />
        <img v-else src="../../../assets/base-title-icon.png" />
        {{ title }}
    </div>
</template>
<script>
export default {
    name: 'BaseTitle',
    props: {
        title: {
            type: String,
            default: ''
        },
        center: {
            type: Boolean,
            default: false
        },
        color: {
            type: String,
            default: ''
        },
        icon: {
            type: String,
            default: ''
        }
    }
}
</script>
<style>
.base_title {
    font-size: 40px;
    color: #27b7cd;
    position: relative;
    padding-left: 14px;
    display: flex;
    align-items: center;
}
.base_title img {
    width: 26px;
    height: 26px;
    margin-left: -54px;
    margin-right: 14px;
}
.center {
    justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/components/modules/base/base-title.vue